import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { TextField, Typography } from "@material-ui/core";
import StandardModal from "./StandardModal";
import { addAssignment } from "../../state/teacherData/teacherDataReducer";
import ModalSize from "./ModalSize";
import FirebaseService from "../../services/firebase/FirebaseService";
import { RootState } from "../../state/configureStore";
import { useAssignmentModalState } from "./modalHooks";

interface CopyAssignmentModalProps {
  open: boolean;
  cancelClose: () => void;
}
const CopyAssignmentModal = (props: CopyAssignmentModalProps) => {
  const { loadingProps, enqueueSnackbar, assignment, title, history } = useAssignmentModalState();
  const [copyName, setCopyName] = useState(`Copy of ${title}`);
  const displayName = useSelector((state: RootState) => state.currentUserState.currentUser?.displayName) || "";
  const duplicateAssignment = async () => {
    if (!assignment) return;
    try {
      const { id } = await FirebaseService.copyAssignment(assignment?.assignmentDetails, displayName, copyName);
      if (!id) throw new Error("Could not copy assignment!");
      const newAssignment = await FirebaseService.getAssignment(id);
      addAssignment(newAssignment);
      enqueueSnackbar(`Created ${newAssignment.title}`, "success");
      props.cancelClose();
      history.push(`/Assignments/${newAssignment.id}`);
    } catch (e) {
      enqueueSnackbar("Could not copy this assignment", "error");
    }
  };

  useEffect(() => {
    setCopyName(`Copy of ${title}`);
  }, [title, props.open]);

  return (
    <StandardModal
      title="Copy Assignment?"
      size={ModalSize.medium}
      submitButtonText="Duplicate"
      onSubmit={duplicateAssignment}
      {...loadingProps}
      {...props}
    >
      <Typography variant="subtitle1">Do you want to copy {title}?</Typography>
      <TextField
        value={copyName}
        variant="outlined"
        onChange={({ target }) => setCopyName(target.value)}
        fullWidth
        label="New Assignment Title"
        style={{ marginTop: 16 }}
      />
    </StandardModal>
  );
};

export default CopyAssignmentModal;
